import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'

import { ButtonType } from '@/components/atoms/button'
import { FrontTabletButton } from '@/components/molecules/front-tablet/button'
import { createSelfCheckinResponsiveStyle, FrontTabletResponsiveToken } from '@/utils/front-tablet-responsive-style'

export type DeviceSettingsConnectionTest = {
  onTest: () => void
  isDisabled: boolean
}

export type DeviceSettingsModalFooterProps = {
  isDirty: boolean
  onCancel: () => void
  onSave: () => void
  // 接続テストに対応しないタブ（プリンター・カード発行機）では渡さない
  connectionTest?: DeviceSettingsConnectionTest
}

export const DeviceSettingsModalFooter: React.FC<DeviceSettingsModalFooterProps> = props => {
  const { t } = useTranslation()

  // 保存前の値で接続しても意味がないため、編集中は接続テストを出さず保存・キャンセルに切り替える
  if (props.isDirty) {
    return (
      <div css={buttonGroupStyle}>
        <FrontTabletButton key="cancel" buttonType={ButtonType.Secondary} onClick={props.onCancel} customCss={modalButtonStyle}>
          {t('Cancel')}
        </FrontTabletButton>
        <FrontTabletButton key="save" buttonType={ButtonType.Primary} onClick={props.onSave} customCss={modalButtonStyle}>
          {t('Save')}
        </FrontTabletButton>
      </div>
    )
  }

  if (!props.connectionTest) return null

  const { onTest, isDisabled } = props.connectionTest

  return (
    <FrontTabletButton
      buttonType={isDisabled ? ButtonType.BorderDisabled : ButtonType.Secondary}
      onClick={onTest}
      isDisabled={isDisabled}
      width={200}
      customCss={css(modalButtonStyle, connectionTestButtonStyle)}
    >
      {t('Connection test')}
    </FrontTabletButton>
  )
}

const modalButtonStyle = css(
  createSelfCheckinResponsiveStyle({
    landscape11: { fontSize: FrontTabletResponsiveToken.standardButtonFontSize.landscape11 },
    portrait: { fontSize: FrontTabletResponsiveToken.standardButtonFontSize.portrait },
    landscape13: { fontSize: FrontTabletResponsiveToken.standardButtonFontSize.landscape13 },
  }),
)

const buttonGroupStyle = css({
  display: 'flex',
  alignItems: 'center',
  gap: 32,
  width: 'max-content',
  marginLeft: 'auto',
})

// ModalFooter が justifyContent: flex-end のため、左寄せは auto マージンで打ち消す
const connectionTestButtonStyle = css({ marginRight: 'auto' })
